import React, { useState, useEffect, useRef } from "react";
 
import DropdownList from "react-widgets/DropdownList";
 
export const ComboboxField = ({
  index,
  id,
  name,
  code,
  description,
  label,
  placeholder,
  error,
  data,
  setValue,
  getvalue = () => { },
  disabled,
  onChangeValue = () => { },
  extraLabel = "",
  required,
  fireOnMount = true,
  errors = {
    name: "test",
  },
}) => {
  const [selectedData, setSelectedData] = useState(setValue);
  const firstRenderRef = useRef(true);
 
  useEffect(() => {
    let obj = {
      ...selectedData,
      textField: name,
      textCode: code,
      textDesc: description,
      index: index,
      status: selectedData?.name ? true : false,
      label: label,
    };
 
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      if (!fireOnMount) return;
    }
 
    getvalue(obj);
 
    if (selectedData) {
      onChangeValue(index, name, selectedData.name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getvalue, selectedData]);
 
  return (
    <>
      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
        {label} {required ? <span style={{ color: 'red' }}> *</span> : ""}{" "}
        {extraLabel !== "" ? (
          <i className="bi bi-info-circle" title={extraLabel}></i>
        ) : (
          ""
        )}
      </label>
      <DropdownList
        id={id}
        name={name}
        className={`dropdownHive w-full rounded-md ${error ? "border-red-dropdown" : ""}`}
        data={data}
        dataKey="id"
        textField="name"
        defaultValue={setValue}
        value={setValue}
        onChange={(value) => setSelectedData(value)}
        filter="contains"
        placeholder={placeholder}
        disabled={disabled}
      />
      {error && (
        <span className="text-red-500 text-md fieldErrMsg">{error}</span>
      )}
    </>
  );
};
 
export const ComboboxField2 = ({
  index,
  id,
  name,
  code,
  description,
  label,
  placeholder = "",
  error,
  data = [],
  value,
  getvalue = () => { },
  onChangeValue = () => { },
  disabled = false,
  extraLabel = "",
  required = false,
}) => {
  const handleDropdownChange = (selectedItem) => {
    if (!selectedItem) return;
 
    getvalue({
      ...selectedItem,
      textField: name,
      textCode: code,
      textDesc: description,
      index,
      label,
      status: true,
    });
 
    onChangeValue(index, name, selectedItem.name);
  };
 
  const selectedObject =
    data?.find((item) => item?.name === value) || null;
 
  return (
    <>
      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
        {label}
        {required && (
          <span style={{ color: "red" }}> *</span>
        )}
 
        {extraLabel && (
          <i
            className="bi bi-info-circle ms-1"
            title={extraLabel}
          ></i>
        )}
      </label>
 
      <DropdownList
        id={id}
        name={name}
        className={`dropdownHive w-full rounded-md ${error ? "border-red-dropdown" : ""
          }`}
        data={data}
        dataKey="id"
        textField="name"
        value={selectedObject}
        onChange={handleDropdownChange}
        filter="contains"
        placeholder={placeholder}
        disabled={disabled}
      />
 
      {error && (
        <span className="text-red-500 text-md fieldErrMsg">
          {error}
        </span>
      )}
    </>
  );
};
 
export const ComboboxField3 = ({
  index,
  id,
  name,
  code,
  description,
  label,
  placeholder,
  error,
  data,
  setValue,
  getvalue = () => { },
  disabled,
  onChangeValue = () => { },
  extraLabel = "",
  required,
  errors = {
    name: "test",
  },
}) => {
  const findSelected = (val, dat) => {
    if (val && dat?.length) {
      return dat.find((item) => item?.name === val || (description && item?.[description] === val)) || null;
    }
    return null;
  };
 
  const [selectedData, setSelectedData] = useState(() => findSelected(setValue, data));
 
  const resolvedData = findSelected(setValue, data);
 
  useEffect(() => {
    if (resolvedData && resolvedData?.name !== selectedData?.name) {
      setSelectedData(resolvedData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, data]);
 
  useEffect(() => {
    if (!selectedData?.name) return;
    let obj = {
      ...selectedData,
      textField: name,
      textCode: code,
      textDesc: description,
      index: index,
      status: true,
      label: label,
    };
 
    getvalue(obj);
 
    if (selectedData) {
      onChangeValue(index, name, selectedData.name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedData]);
 
  return (
    <>
      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
        {label} {required ? <span style={{ color: 'red' }}> *</span> : ""}{" "}
        {extraLabel !== "" ? (
          <i className="bi bi-info-circle" title={extraLabel}></i>
        ) : (
          ""
        )}
      </label>
      <DropdownList
        id={id}
        name={name}
        className={`dropdownHive w-full rounded-md ${error ? "border-red-dropdown" : ""
          }`}
        data={data}
        dataKey="id"
        textField="name"
        value={selectedData}
        onChange={(value) => setSelectedData(value)}
        filter="contains"
        placeholder={placeholder}
        disabled={disabled}
      />
      {error && (
        <span className="text-red-500 text-md fieldErrMsg">{error}</span>
      )}
    </>
  );
};
 
export const ComboboxField4 = ({
  index,
  id,
  name,
  label,
  placeholder,
  error,
  data,
  value,          // new
  onChange,       // new
  disabled,
  extraLabel = "",
  required,
}) => {
  const findSelected = (val) => {
    if (!val || !data?.length) return null;
    return data.find(item => item.value === val || item.name === val) || null;
  };
 
  const [selectedData, setSelectedData] = useState(() => findSelected(value));
 
  useEffect(() => {
    const newSelected = findSelected(value);
    if (newSelected && newSelected.name !== selectedData?.name) {
      setSelectedData(newSelected);
    }
 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, data]);
 
  const handleSelect = (item) => {
    setSelectedData(item);
    if (onChange) {
      onChange(item?.value ?? item?.name ?? '');
    }
  };
 
  return (
    <>
      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
        {label} {required ? <span style={{ color: 'red' }}> *</span> : ""}{" "}
        {extraLabel !== "" ? <i className="bi bi-info-circle" title={extraLabel}></i> : ""}
      </label>
      <DropdownList
        id={id}
        name={name}
        className={`dropdownHive w-full rounded-md ${error ? "border-red-dropdown" : ""}`}
        data={data}
        dataKey="id"
        textField="name"
        value={selectedData}
        onChange={handleSelect}
        filter="contains"
        placeholder={placeholder}
        disabled={disabled}
      />
      {error && <span className="text-red-500 text-md fieldErrMsg">{error}</span>}
    </>
  );
};
 
 
 
 